import type { Account, UserInfo } from '../../../generated-types';

export default (account: Account | undefined, userInfo: UserInfo | undefined) => {
    const primaryOwner = account?.owners.find((a) => a?.primaryOwner);
    if (primaryOwner?.equalToUserLoggedOn === true) {
        if (typeof userInfo?.age === 'number') {
            return userInfo.age >= 34;
        }
    }
    return account?.status === 'BLOCKEDDEPOSIT' && account.type === 'BSU';
};
